export default __webpack_public_path__ + "static/media/0xbb10c3ba37b4da01a70d6f3f456c5323a11a76fb.92f7e6c8.svg";